module.exports = __webpack_public_path__ + "static/symbiotics-d40cbfc77d482ac321679f3c13e23e53.svg";